export default __webpack_public_path__ + "static/media/leaked_session.aa884d88.svg";